import callApi from './stickerService';

export const getMissionSticker = (info) => callApi({
  method: 'POST',
  endpoint: `/web/sticker`,
  body: info
});
